import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/sagas/membershipDraft/membershipDraft";
import { isModuleActive } from "../../../utils/modules";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import RecurringRevenue from "./smartComponents/recurringRevenue";
import RecurringRevenueChange from "./smartComponents/recurringRevenueChange";
import PreviousRecurringRevenue from "./smartComponents/prevRecurringRevenue";
import RecurringRevenueYearToDate from "./smartComponents/recurringRevenueYearToDate";
import RecurringRevenueYearToDateChange from "./smartComponents/recurringRevenueYearToDateChange";
import PreviousRecurringRevenueYearToDate from "./smartComponents/prevRecurringRevenueYearToDate";
import YearOverYear from "./smartComponents/yearOverYear";
import AverageRevenuePerUnit from "./smartComponents/averageRevenuePerUnit";
import AverageRevenuePerUnitChange from "./smartComponents/averageRevenuePerUnitChange";
import RemainingRevenue from "./smartComponents/remainingRevenue";
import NextMonthRevenue from "./smartComponents/nextMonthRevenue";
import LearnMore from "../../../components/learnMore/learnMore";

export class MembershipDraftsModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initRequest: false,
      moduleHeight: 800
    };
  }

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "Membership Draft")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });
      this.setState({
        initRequest: true
      });
    }

    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      const state = configuratorStore.getState();
      if (
        isModuleActive(state.dashboardConfigurator.preferences, "Membership Draft") &&
        !this.state.initRequest
      ) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({
          initRequest: true
        });
      }
    });

    // Month switcher store
    let previousDate;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.updateAllData(currentDate);
        }
      }
    });
  }

  render() {
    const {
      learnMore: { learnMoreId, title, content },
      currentUser: { sourceType },
      displayAutopays
    } = this.props;
    return (
      <SectionToggle
        title="Membership Revenue"
        learnMore={<LearnMore learnMoreId={learnMoreId} title={title} content={content} html />}
        customClass={`membershipdraftsWidget ${this.props.isLoading ? "" : "active"}`}
        height={this.state.moduleHeight}
        isLoading={this.props.isLoading}
        content={
          <div>
            <div className="section-group height-175">
              <span className="width-50">
                <SectionContainer title="Membership Revenue">
                  <RecurringRevenue />
                  <RecurringRevenueChange />
                </SectionContainer>
              </span>
              {sourceType === "mindbody" || sourceType === "clubready" ? (
                <div>
                  {displayAutopays ? (
                    <span className="width-50">
                      <SectionContainer
                        title={sourceType === "clubready" ? "Remaining This Month" : "Remaining"}
                      >
                        <RemainingRevenue />
                      </SectionContainer>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <span className="width-50">
                  <SectionContainer title="Previous Month Membership Revenue">
                    <PreviousRecurringRevenue />
                  </SectionContainer>
                </span>
              )}
            </div>
            <div className="section-group height-175">
              {sourceType === "mindbody" || sourceType === "clubready" ? (
                <div>
                  {displayAutopays ? (
                    <span className="width-50">
                      <SectionContainer title="Next Month">
                        <NextMonthRevenue />
                      </SectionContainer>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div>
                  <span className="width-50">
                    <SectionContainer title="Membership Revenue Year To Date">
                      <RecurringRevenueYearToDate />
                      <RecurringRevenueYearToDateChange />
                    </SectionContainer>
                  </span>
                  <span className="width-50">
                    <SectionContainer title="Previous Year To Date">
                      <PreviousRecurringRevenueYearToDate />
                    </SectionContainer>
                  </span>
                </div>
              )}
            </div>
            <div className="section-group height-175">
              <span className="width-50">
                <SectionContainer title="Average Membership Revenue">
                  <AverageRevenuePerUnit />
                  <AverageRevenuePerUnitChange />
                </SectionContainer>
              </span>
              {sourceType === "clubready" || sourceType === "mindbody" ? (
                <span className="width-50">
                  <SectionContainer title="Previous Month Membership Revenue">
                    <PreviousRecurringRevenue />
                  </SectionContainer>
                </span>
              ) : (
                ""
              )}
            </div>
            {sourceType === "clubready" || sourceType === "mindbody" ? (
              <div className="section-group height-175">
                <span className="width-50">
                  <SectionContainer title="Membership Revenue Year To Date">
                    <RecurringRevenueYearToDate />
                    <RecurringRevenueYearToDateChange />
                  </SectionContainer>
                </span>
                <span className="width-50">
                  <SectionContainer title="Previous Year To Date">
                    <PreviousRecurringRevenueYearToDate />
                  </SectionContainer>
                </span>
              </div>
            ) : (
              ""
            )}
            <div className="section-group" style={{ width: "100%" }}>
              <span className="top">
                <SectionContainer title="Year over Year Comparison">
                  <YearOverYear />
                </SectionContainer>
              </span>
            </div>
          </div>
        }
      />
    );
  }
}

export default connect(
  (state) => ({
    isLoading: state.membershipDraft.isLoading,
    userParams: state.membershipDraft.currentUser,
    displayAutopays: state.membershipDraft.displayAutopays
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(MembershipDraftsModule);

MembershipDraftsModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  updateAllData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  learnMore: PropTypes.objectOf(PropTypes.string),
  displayAutopays: PropTypes.bool
};
